export default {
    path: "/lock",
    name:"lock",
    component: () => import('@/components/lock/lock.vue'),
    meta:{
        name:"锁屏",
        assess:false
    }
}


// WEBPACK FOOTER //
// ./src/router/modules/lock.js